/**
 * User: Keith
 * Author: Faris
 * Date: 6/24/15
 * Time: 10:30 AM
 */

define('app/views/gallery',['require','./page','hammerjs','text!../../../views/gallery.html'],function(require) {

  // Code template
  var Page = require('./page');
  var Hammer = require('hammerjs');
  // Html templates
  var template = require('text!../../../views/gallery.html');
  
  // Create your own template
  var gallery = Page.extend({
	  // Define using the html template
	  template: _.template(template),
	  
	  events : {
			'click .caretRight' : 'clickNext',
			'touchstart .caretRight' : 'clickNext',
			'swiperight .carets' : 'clickNext',
			'click .caretLeft' : 'clickPrev',
			'touchstart .caretLeft' : 'clickPrev',
			'swipeleft .carets' : 'clickPrev',
			'click .thumb' : 'clickThumb'
	  },

	  // Init function
	  initialize: function() {
		  this.speed = 7000;
		  this.timer;
		  this.isAnimating = false;
		  
		  _.bindAll(this, 'onKeyDown');
		  $(document).bind('keydown', this.onKeyDown);
	  },
	  
	  transitionInComplete: function() {
	      // Hide everything except first slide
	      $('#gallery > div:not(:first)').each(function(i, ele) {
	          $(ele).hide();
	      });
	      $("#gallery").addClass("preloaded");

	      // Hammer events
	      var element = document.getElementById("gallery");
	      var mc = new Hammer(element, {velocity: .5});
	      
	      // listen to events...	      
	      mc.on("swipeleft swiperight", function(e) {
	          this.onSwipe(e, this);
	      }.bind(this));
	      
		  this.startTimer();
	  },
	  
	  transitionOut: function(newPage){
	      $('html').removeClass('fullscreen');
	      clearInterval(this.timer);
	      // Stop all animations
	      $("#gallery div").stop();
          $(document).unbind('keydown', this.onKeyDown);
          // Fallback if the load is taking too long, Simply remove old page
          setTimeout(function() {
              this.$el.detach();
          }.bind(this), 1250);
          
	      TweenMax.to(this.$el, 1, { alpha: 0, onComplete: this.transitionOutComplete, onCompleteScope: this });
	  },
	  
	  startTimer: function() {
		  this.timer = setInterval(this.nextSlide, this.speed);
	  },
	  
	  nextSlide: function() {
		  // Clear/reset all transparency in thumbnails
		  $(".galleryThumbnails div", this.$el).animate({'opacity': 1});
		  
		  // Get id of next thumbnail and fade it out
		  var id = $('#gallery > div:first', this.$el).next().attr('data-slideid');
		  $('div[data-thumbid="'+id+'"]', this.$el).animate({'opacity': .3});
		  
		  $('#gallery > div:first', this.$el).fadeOut(1000, function() {
			  $("#gallery", this.$el).append($('#gallery > div:first', this.$el));
			  this.isAnimating = false;
		  }.bind(this)).next().fadeIn(1000);  
	  },
	  
	  prevSlide: function() {
	      // Clear/reset all transparency in thumbnails
          $(".galleryThumbnails div", this.$el).css('opacity', 1);
          // Set current slide opacity to fade out
          var id = $('#gallery > div:last', this.$el).attr('data-slideid');

          $('div[data-thumbid="'+id+'"]', this.$el).animate({'opacity': .3});
	      
		  $('#gallery > div:last', this.$el).fadeIn(1000, function() {
			  $("#gallery", this.$el).prepend($('#gallery > div:last', this.$el));
			  this.isAnimating = false;
		  }.bind(this));
		  $('#gallery > div:first', this.$el).fadeOut(1000);
	  },
	  
	  onSwipe: function(e, that) {
          // Swipe right
	      if(e.direction==2) {
	          that.clickNext();
	      }
	      // Swipe left
	      if(e.direction==4) {
	          that.clickPrev();
	      }
	  },
	  
	  clickNext: function() {
	      if(!this.isAnimating) {
	          this.isAnimating = true;
    		  // Pause, then restart again	  
    		  this.pauseAndRestartTimer();
    		  this.nextSlide();
	      }
	  },
	  
	  clickPrev: function() {		  
	      if(!this.isAnimating) {
	          this.isAnimating = true;
    		  // Pause, then restart again
    		  this.pauseAndRestartTimer();
    		  this.prevSlide();
	      }
	  },
	  
	  clickThumb: function(e) {
	      if(!this.isAnimating) {
	          this.pauseAndRestartTimer();
	          this.isAnimating = true;
    	      var id = $(e.target).data('thumbid');
    	      
    	      // Sort slides until the one we want is first on the list
    	      var count = 0;
    	      var max = $('#gallery > div', this.$el).length;
    	      while($('#gallery > div:first', this.$el).data('slideid')!=id) {
    	          $('#gallery > div:first', this.$el).fadeOut(1000);
    	          $("#gallery", this.$el).append($('#gallery > div:first', this.$el));
    	          
    	          // Stop if max is exceeded
    	          count++;
    	          if(count>max) {
    	              console.log("Breaking")
    	              break;
    	          }
    	      }
    	      
    	      // Clear/reset all transparency in thumbnails
              $(".galleryThumbnails div", this.$el).css('opacity', 1);
              
              // Get id of thumbnail and fade current selected thumb
              var id = $('#gallery > div:first', this.$el).attr('data-slideid');
              $('div[data-thumbid="'+id+'"]', this.$el).animate({'opacity': .3});
    	      
    	      // Transition
    	      $('#gallery > div:first', this.$el).fadeIn(1000, function() {
    	          
    	          this.isAnimating = false;
    	      }.bind(this));
	      }
	  },
	  
	  pauseAndRestartTimer: function() {
		  clearInterval(this.timer);		  
		  var thing = this;
		  this.timer = setInterval(function() {
			  thing.nextSlide();
		  }, this.speed*2);
	  },
	  
	  onKeyDown: function(e) {
		// Left
		if(e.which == 37) {
			this.clickPrev();
		}
		// Right
		if(e.which == 39 ) {
			this.clickNext();
		}
		
	  },
	  
	  swipe : function() {
		  alert("SWIPED");
	  },
	  
	  afterRender: function() {
          $('html').addClass('fullscreen');
      }
  });  
  return gallery;
});
